export default __webpack_public_path__ + "static/media/PowellCatLocation-06.eb85bcf7.jpg";